import { PLACEHOLDER_DATE_TIME_FORMAT } from '@/constants/date.constants';

type MarkerInfoBadgeProps = {
  label: string;
  value: string;
};

export const MarkerInfoBadge = ({ label, value }: MarkerInfoBadgeProps) => {
  const isPending = value === PLACEHOLDER_DATE_TIME_FORMAT;

  return (
    <div className="px-4 py-2 rounded-xl whitespace-nowrap text-base text-center uppercase border border-orange-10 bg-white/80 backdrop-blur shadow-sm text-base-5">
      {label} <br /> {isPending ? 'Pending' : value}
    </div>
  );
};
